/* ============================================================
   Filter: fold grupper sammen (KUN desktop) + skjul enkelt-værdi (alle bredder).
   Mobil (<=760px) styres af 8.0's egen filter-drawer — vi rører den ikke,
   så ingen dobbeltpil og udfoldning virker på mobil.
   ============================================================ */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 1001px)';
  function isDesktop() { return window.matchMedia(DESKTOP).matches; }

  /* ---- 1) CSS: foldning + pil KUN på desktop ---- */
  var css =
    '@media (min-width: 1001px){' +
      '#filter h4[data-filter-toggle]{cursor:pointer;position:relative;padding-right:30px;user-select:none;}' +
      '#filter h4[data-filter-toggle]::after{content:"";position:absolute;right:8px;top:50%;width:9px;height:9px;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:translateY(-75%) rotate(45deg);transition:transform .2s ease;pointer-events:none;opacity:.7;}' +
      '#filter h4[data-filter-toggle].is-open::after{transform:translateY(-25%) rotate(-135deg);}' +
      '#filter ul[data-filter-toggle]{display:none !important;}' +
      '#filter h4[data-filter-toggle].is-open + ul[data-filter-toggle]{display:block !important;}' +
      '#filter h4[data-filter-toggle] + .input-range{display:none !important;}' +
      '#filter h4[data-filter-toggle].is-open + .input-range{display:block !important;}' +
    '}';
  var style = document.createElement('style');
  style.id = 'bekent-filter-collapse';
  style.textContent = css;
  document.head.appendChild(style);

  /* ---- 2) Skjul enkelt-værdi (alle bredder) + fold aktive ud (kun desktop) ---- */
  function applyState() {
    var params = new URLSearchParams(window.location.search);
    var desktop = isDesktop();
    var active = {};

    /* Pris-slider: dokument-bred (draweren bruger ikke #filter) og ALLE bredder.
       Temaets accordion folder ul-grupper i draweren, men ikke .input-range — det gør vi. */
    document.querySelectorAll('h4[data-filter-toggle]').forEach(function (h) {
      var sib = h.nextElementSibling;
      if (!sib || !sib.classList || !sib.classList.contains('input-range')) return;
      if (h.classList.contains('is-open')) {
        sib.style.removeProperty('display');
      } else {
        sib.style.setProperty('display', 'none', 'important');
      }
    });

    document.querySelectorAll('#filter h4[data-filter-toggle]').forEach(function (h) {
      var ul = h.nextElementSibling;
      if (ul && ul.classList && ul.classList.contains('input-range')) return;
      if (!ul || ul.tagName !== 'UL') return;

      var options = ul.querySelectorAll('li:not(.link-more)').length;
      if (options <= 1) {
        h.style.setProperty('display', 'none', 'important');
        ul.style.setProperty('display', 'none', 'important');
        return;
      } else {
        // Blev flere-værdi igen (fx efter fravalg) → vis
        h.style.removeProperty('display');
        ul.style.removeProperty('display');
      }

      if (desktop) {
        var inp = ul.querySelector('input[name^="filter."]');
        if (inp && params.has(inp.name)) active[h.getAttribute('data-filter-toggle')] = true;
      }
    });

    var gte = params.get('filter.v.price.gte');
    var lte = params.get('filter.v.price.lte');
    if ((gte && gte !== '0') || lte) {
      document.querySelectorAll('h4[data-filter-toggle]').forEach(function (h) {
        var sib = h.nextElementSibling;
        if (sib && sib.classList && sib.classList.contains('input-range')) h.classList.add('is-open');
      });
    }
    if (desktop) {
      document.querySelectorAll('#filter h4[data-filter-toggle]').forEach(function (h) {
        if (active[h.getAttribute('data-filter-toggle')]) h.classList.add('is-open');
      });
    }
  }

  /* ---- 3) Klik på overskrift = fold ud/sammen ---- */
  document.addEventListener('click', function (e) {
    var h = e.target.closest('h4[data-filter-toggle]');
    if (!h) return;
    if (e.target.closest('input, label')) return;
    var a = e.target.closest('a');
    if (a && !a.classList.contains('header-toggle')) return; /* rigtige links ignoreres; temaets toggle-anker ikke */

    var sib = h.nextElementSibling;
    var isPrice = sib && sib.classList && sib.classList.contains('input-range');

    /* Pris: alle bredder, også i draweren. Øvrige grupper: kun desktop og kun i #filter. */
    if (!isPrice && (!isDesktop() || !h.closest('#filter'))) return;

    h.classList.toggle('is-open');
    h.setAttribute('aria-expanded', h.classList.contains('is-open') ? 'true' : 'false');
    applyState();
  });

  /* ---- 4) Watcher: 8.0 AJAX-erstatter #filter ---- */
  applyState();
  setInterval(applyState, 200);
})();
